import EventSign from './event-sign'

export default EventSign
